module.exports = __webpack_public_path__ + "img/bj.42809967.png";